export const DATE_FORMAT = "YYYY-MM-DD";


export const EQUIPMENT_STATE = [{
    value: "PRODUCTION",
    label: "Producción",
    text: "Producción",
},
{
    value: "BROKEN",
    label: "Averiado",
    text: "Averiado",
},
{
    value: "REPAIRING",
    label: "En reparación",
    text: "En reparación",
},
{
    value: "REPAIRED",
    label: "Reparado",
    text: "Reparado",
},
];


export const INCIDENT_STATUS = [{
    value: "PENDING",
    label: "Pendiente",
    text: "Pendiente",
},
{
    value: "SCHEDULED",
    label: "Programada",
    text: "Programada",
},
{
    value: "STARTED",
    label: "Iniciada",
    text: "Iniciada",
},
{
    value: "DELAYED",
    label: "Retrasada",
    text: "Retrasada",
},
{
    value: "RESCHEDULED",
    label: "Reprogramada",
    text: "Reprogramada",
},
{
    value: "FINISHED",
    label: "Finalizada",
    text: "Finalizada",
},
];


export const INCIDENT_CREATIONTYPE = [{
    value: "MANUAL",
    label: "Manual",
    text: "Manual",
},
{
    value: "AUTOMATIC",
    label: "Automática",
    text: "Automática",
},
];


export const SHIFTTYPE_SHIFTPERIOD = [     {
        value: "MORNING",
        label: "Mañana",
        text: "Mañana",
    },
    {
        value: "AFTERNOON",
        label: "Tarde",
        text: "Tarde",
    },
    {
        value: "NIGHT",
        label: "Noche",
        text: "Noche",
    },
];


export const TIMECHANGEREQUEST_STATUS = [     {
        value: "PENDING",
        label: "Pendiente",
        text: "Pendiente",
    },
    {
        value: "APPROVED",
        label: "Aprobada",
        text: "Aprobada",
    },
    {
        value: "REJECTED",
        label: "Rechazada",
        text: "Rechazada",
    },
];


export const TIMECHANGEREQUEST_ACTION = [     {
        value: "CHANGE_START",
        label: "Cambiar fecha de inicio",
        text: "Cambiar fecha de inicio",
    },
    {
        value: "CHANGE_END",
        label: "Cambiar fecha de fin",
        text: "Cambiar fecha de fin",
    },
    {
        value: "DELETE",
        label: "Borrar fichaje",
        text: "Borrar fichaje",
    },
];


export const MAINTENANCE_STATUS = [     {
        value: "PENDING",
        label: "Pendiente",
        text: "Pendiente",
    },
    {
        value: "FINISHED",
        label: "Finalizado",
        text: "Finalizado",
    },
];
